module.exports = __webpack_public_path__ + "images/bosch_small0b61f856ba640430d3bd5e29d25ccdd6.png";